import { useCurrentStateAndParams } from "@uirouter/react";
import DurationService from "app/services/DurationService";
import { chosenSites } from "app/common/services/chosenSites";
import { FILTERS_OBJECT } from "../configuration/constants";
import type { CompetitiveParams, CompetitiveFilterType, CompetitiveSiteFilter } from "../types/common";
import getChosenSitesFilters from "../helpers/getChosenSitesFilters";

type HookReturnType = {
    params: CompetitiveParams;
    availableFilters: CompetitiveFilterType;
    sortDirection: string;
    field: string;
    selectedSite: string;
    selectedSiteFilter: CompetitiveSiteFilter;
};

const useCompetitiveQueryParams = (): HookReturnType => {
    const isCompare = chosenSites.isCompare();
    const chosenSiteFilters = getChosenSitesFilters();

    const {
        params: {
            key,
            country,
            isWWW,
            duration,
            similarsites_orderby,
            similarsites_filters,
            selectedSite: selectedSiteFromParams,
        },
    } = useCurrentStateAndParams();

    const selectedSiteFilterFromChoosen =
        selectedSiteFromParams && chosenSiteFilters.find((site) => site.value === selectedSiteFromParams);

    const selectedSiteFilter = selectedSiteFilterFromChoosen ? selectedSiteFilterFromChoosen : chosenSiteFilters[0];

    const { value: selectedSite } = selectedSiteFilter;

    const availableFilters: CompetitiveFilterType = {};
    if (similarsites_filters) {
        similarsites_filters.split("+").forEach((filter: string) => {
            const values = filter.split(";");
            availableFilters[values[0]] = { ...FILTERS_OBJECT[values[0]], value: values[2] };
        });
    }

    const filter = Object.keys(availableFilters)
        .map((filter) => {
            const { action, value } = availableFilters[filter];
            return [filter, action, `"${value}"`].join(";");
        })
        .join(",");

    let field = "Affinity";
    let sortDirection = "desc";
    if (similarsites_orderby) {
        [field, sortDirection] = similarsites_orderby.split(" ");
    }
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const params = {
        filter,
        country,
        from,
        includeSubDomains: isWWW === "*",
        isWindow: !!isWindow,
        keys: isCompare ? selectedSite : key,
        orderBy: `${field} ${sortDirection}`,
        to,
        timeGranularity: "Monthly",
    };

    return {
        params,
        availableFilters,
        sortDirection,
        field,
        selectedSite,
        selectedSiteFilter,
    };
};

export default useCompetitiveQueryParams;
